import React from 'react'
import PropTypes from 'prop-types'
import IconPrevious from '@material-ui/icons/KeyboardArrowLeft'
import IconNext from '@material-ui/icons/KeyboardArrowRight'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import Panel from './Panel'
import Button from './Button'


const styles = () => ({
  root: {
    marginTop: 30,
    marginBottom: 10,
  },
  leftIcon: {
    marginLeft: 10,
  },
  rightIcon: {
    marginRight: 10,
  },
  text: {
    marginLeft: 10,
    marginRight: 10,
    display: 'inline-block',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})


const createPaginationHandler = (page, onItemChange) => () => onItemChange(page)


const PaginationItem = ({
  item,
  items,
  label,
  classes,
  onItemChange,
}) => {
  const itemIndex = item ? items.findIndex(x => x === item) : -1

  return (
    <Panel>
      <Button
        color="secondary"
        disabled={itemIndex <= 0}
        onClick={createPaginationHandler(items[itemIndex - 1], onItemChange)}
      >
        <IconPrevious className={classes.leftIcon} />
        Previous
      </Button>

      <Typography className={classes.text}>{items.length} {label}</Typography>

      <Button
        color="primary"
        disabled={(itemIndex) >= (items.length - 1)}
        onClick={createPaginationHandler(items[itemIndex + 1], onItemChange)}
      >
        <IconNext className={classes.leftIcon} />
        Next
      </Button>
    </Panel>
  )
}


PaginationItem.defaultProps = {
  page: 0,
  count: 0,
  limit: 20,
  items: [],
  totalPages: 0,
  label: 'items',
  itemName: 'item',
  onItemChange: () => { },
}


PaginationItem.propTypes = {
  item: PropTypes.object,
  page: PropTypes.number,
  limit: PropTypes.number,
  count: PropTypes.number,
  label: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  classes: PropTypes.object,
  itemName: PropTypes.string,
  onItemChange: PropTypes.func,
  totalPages: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object),
}


export default withStyles(styles)(PaginationItem)
